import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'ShippingAndReturnsIrisLazy',
        path: () => path.join(__dirname, './ShippingAndReturnsIris'),
        resolve: () => require.resolveWeak('./ShippingAndReturnsIris'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "ShippingAndReturnsIrisLazy" */ './ShippingAndReturnsIris'
                ),
            ]).then((proms) => proms[0]),
    })
);
